import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

export const resetPassword = (email) => MessageBroker.send(RequestUrls.resetPassword, { address: email }, { Authorization: false });

export const resetPasswordWithToken = (token, newPassword) =>
  MessageBroker.send(
    RequestUrls.resetPasswordWithToken,
    {
      token,
      newPassword,
    },
    { Authorization: false }
  );
